import React from 'react';

/**
 * Shared warning icon for all WCN inputs.
 */
const WcnWarningIcon: React.FC = () => (
    <span className="wcn-input-warning-icon" aria-label="warning">
        <i className="bi bi-exclamation-triangle" />
    </span>
);

export default WcnWarningIcon;
